// Owner: page-editor (wave 2, plan §3.1, §9.9). Block pages open in the page editor; presentations and
// document templates keep their editors (they move to /decks and /documents with their owners).
import { createFileRoute } from '@tanstack/react-router';
import { PageEditorRoute } from '../../../features/page-editor/PageEditor';

export const Route = createFileRoute('/_app/pages/$pageId')({ component: PageRoute });

function PageRoute() {
  const { pageId } = Route.useParams();
  return <PageEditorRoute key={pageId} id={pageId} />;
}
